import { EMR_TYPE } from '@common/types';
import * as yup from 'yup';
import {
  addOptionalNullableToSchema,
  optionalNullableNameSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';

export const generalSchema = yup.object().shape({
  name: requiredNameSchema,
  organization: yup.string().required(requiredErrorMessage),
  emr: yup
    .string()
    .required(requiredErrorMessage)
    .oneOf(Object.values(EMR_TYPE)),
  emr_other: yup
    .string()
    .optional()
    .test({
      name: 'required',
      message: requiredErrorMessage,
      test: (value = '', context) => {
        const emr = context.parent.emr;

        return emr === EMR_TYPE.OTHER ? value > '' : true;
      },
    }),

  google_places_id: addOptionalNullableToSchema(yup.string()),
  street: requiredNameSchema,
  suite: optionalNullableNameSchema,
  city: requiredNameSchema,
  state: stateSchema.required(requiredErrorMessage),
  zip_code: zipSchema.required(requiredErrorMessage),
  county: optionalNullableNameSchema,
});
